import React from 'react'
import styled from '@emotion/styled'

import {SmoothScrollNavigation} from '@vio/atlas/helpers/SmoothScrollNavigation'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const AvailabilityTileSkeleton = styled(SkeletonLoader)`
  min-width: 38%;

  ${linariaMq.mobileLg} {
    min-width: 28%;
  }
`

export const Loading = () => {
  return (
    <div>
      <SmoothScrollNavigation itemsGap={'s300'}>
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
        <AvailabilityTileSkeleton marginTop={0} />
      </SmoothScrollNavigation>
    </div>
  )
}
